import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lk-users-card',
  templateUrl: './users-card.component.html',
  styleUrls: ['./users-card.component.scss']
})
export class UsersCardComponent implements OnInit {
  @Input() users;


  constructor() { }

  ngOnInit() {
    console.log(this.users);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/users-card/users-card.component.ts